import * as RTooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { memo, useMemo } from "react";

import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";
import { getTooltipTitleFontType } from "@molecules/tooltip/helper";
import {
  ITooltipPositionEnum,
  ITooltipSizeEnum,
} from "@molecules/tooltip/types";

import classes from "./styles.module.scss";

import type { ITooltipProps } from "@molecules/tooltip/types";

export const Tooltip = memo(function Tooltip({
  contentClassName,
  className,
  icon,
  size = ITooltipSizeEnum["2X_Small"],
  position = ITooltipPositionEnum.Bottom,
  title,
  description,
  children,
}: ITooltipProps) {
  const titleFontType = useMemo(() => getTooltipTitleFontType(size), [size]);

  return (
    <RTooltip.Root>
      <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content
          className={clsx(classes.label, contentClassName)}
          side={position}
          sideOffset={0}
          data-size={size}
        >
          <div
            className={clsx(classes.label__container, className)}
            data-size={size}
          >
            {icon && (
              <div className={clsx(classes.label__icon)}>
                <Icon
                  name={icon}
                  fontSize={
                    size === ITooltipSizeEnum["2X_Small"] ? "fs-16" : "fs-20"
                  }
                  color={"icon-sub-600"}
                />
              </div>
            )}
            <div className={clsx(classes.label__content)} data-size={size}>
              <Typography fontType={titleFontType}>{title}</Typography>
              <Typography
                fontType={"paragraph-x-small"}
                themeColor={"text-sub-600"}
                fontSize={
                  size === ITooltipSizeEnum["2X_Small"] ? "fs-11" : undefined
                }
                textWrap
              >
                {description}
              </Typography>
            </div>
          </div>
          <RTooltip.Arrow asChild>
            <div className={clsx(classes.triangle)}>
              <svg
                width={"18"}
                height={"9"}
                viewBox={"0 0 18 9"}
                fill={"none"}
                xmlns={"http://www.w3.org/2000/svg"}
              >
                <path
                  d={
                    "M2.64645 6.64645L1.79289 7.5H3L15 7.5H16.2071L15.3536 6.64645L10.7678 2.06066C9.79146 1.08435 8.20854 1.08435 7.23223 2.06066L2.64645 6.64645Z"
                  }
                  fill={"white"}
                  stroke={"#E1E4EA"}
                />
                <rect
                  width={"18"}
                  height={"2"}
                  rx={"1"}
                  transform={"matrix(1 0 0 -1 0 9)"}
                  fill={"white"}
                />
              </svg>
            </div>
          </RTooltip.Arrow>
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  );
});
